export default __webpack_public_path__ + "static/media/mail.3db5473a.svg";